import { useEffect, useMemo, useRef } from "react";
import Lottie from "lottie-react";
import { resolvePotionStarsAnimation } from "../utils/colorizeLottieAnimation";
import { formatPotionAbsenceLabel } from "../constants/potions";
import PotionBannerTitle from "./PotionBannerTitle";
import potionArabesqueSrc from "../assets/arabesquepotion.svg";

export default function CloverPotionCard({ potion, quantity = 0, onUse }) {
  const lottieRef = useRef(null);
  const starsAnimation = useMemo(
    () => resolvePotionStarsAnimation(potion),
    [potion]
  );
  const canUse = quantity > 0;

  useEffect(() => {
    lottieRef.current?.stop();

    const timeoutId = window.setTimeout(() => {
      lottieRef.current?.goToAndPlay(0, true);
    }, potion.starsAnimationDelay ?? 0);

    return () => window.clearTimeout(timeoutId);
  }, [potion.starsAnimationDelay, starsAnimation]);

  return (
    <article className={`potion-card ${potion.themeClass}`}>
      <div className="potion-card__crest">
        <h3 className="potion-card__title">{potion.name}</h3>
        <PotionBannerTitle name={potion.name} />
        <div className="potion-card__visual">
          <div className="potion-card__icon-wrap">
            <div className="potion-card__lottie-wrap" aria-hidden="true">
              <Lottie
                lottieRef={lottieRef}
                animationData={starsAnimation}
                loop
                className="potion-card__lottie"
                rendererSettings={{ preserveAspectRatio: "xMidYMid meet" }}
              />
            </div>
            <img
              src={potion.image}
              alt=""
              className="potion-card__image"
              decoding="sync"
              draggable={false}
            />
          </div>
        </div>
      </div>

      <div className="potion-card__description-wrap">
        <p className="potion-card__description">{potion.description}</p>

        <img
          src={potionArabesqueSrc}
          alt=""
          className="potion-card__arabesque"
          draggable={false}
          aria-hidden="true"
        />

        <div className="potion-card__actions">
          <div className="potion-card__clover-price-block">
            <p className="potion-card__clover-reward">Récompense de jeu</p>
            <p className="potion-card__clover-price">
              Ne fermez pas la roue avant le tirage, la potion serait quand même consommée
            </p>
          </div>

          <button
            type="button"
            className="potion-card__obtain"
            disabled={!canUse}
            onClick={() => onUse?.(potion)}
          >
            Utiliser
          </button>
        </div>
      </div>

      <div className="potion-card__quantity">
        {quantity > 0 ? (
          <>
            <span className="potion-card__quantity-label">Vous en possédez</span>
            <strong className="potion-card__quantity-value">{quantity}</strong>
          </>
        ) : (
          <span className="potion-card__quantity-label">
            {formatPotionAbsenceLabel(potion)}
          </span>
        )}
      </div>
    </article>
  );
}
